export let EditDraftsTableColumns = /*#__PURE__*/function (EditDraftsTableColumns) {
  EditDraftsTableColumns["Client"] = "Client";
  EditDraftsTableColumns["AdditionalRecipients"] = "Additional recipients";
  EditDraftsTableColumns["AgreementName"] = "Agreement name";
  EditDraftsTableColumns["EffectiveDate"] = "Effective date";
  EditDraftsTableColumns["ModifiedBy"] = "Modified by";
  EditDraftsTableColumns["LastModified"] = "Last modified";
  EditDraftsTableColumns["ExpirationDate"] = "Expiration date";
  EditDraftsTableColumns["IntroductoryMessage"] = "Introductory message";
  EditDraftsTableColumns["IntroductoryVideo"] = "Introductory video";
  EditDraftsTableColumns["TermsOfService"] = "Terms of service";
  EditDraftsTableColumns["AgreementNote"] = "Agreement note";
  EditDraftsTableColumns["AutoApproveAmendments"] = "Auto approve amendments";
  EditDraftsTableColumns["AutoApproveOutOfScopeCharges"] = "Auto approve out-of-scope charges";
  EditDraftsTableColumns["NumberOfDaysUntilPaymentIsDue"] = "Number of days until the payment is due";
  EditDraftsTableColumns["PaymentMethodRequiredForSigning"] = "Payment method required for signing";
  EditDraftsTableColumns["CreditCardProcessingFees"] = "Credit card processing fees";
  EditDraftsTableColumns["ManualApprovalOfEachPayment"] = "Manual approval of each payment";
  return EditDraftsTableColumns;
}({});